export const themePrimary = '#953735';
export const textOnThemePrimary = '#f0f0f0';
export const paleGray = '#ddd9c3';
